import React, { useEffect, useState } from 'react'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getStudentApprovedTutorDetail } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Modal, ModalBody } from "react-bootstrap";
const host = process.env.REACT_APP_API_SERVER
const StudentCourseDetails = () => {


    const dispatch = useDispatch();
    const { b64id } = useParams();
    const navigate = useNavigate();
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const {
        loadingStudentApprovedTutorDetailsApi,
        StudentApprovedTutorDetailsApiData,
        StudentApprovedTutorDetailsApiError


    } = useSelector(state => state?.StudentReducer);

    useEffect(() => {
        try {

            const requestId = atob(b64id);
            // console.log(requestId)

            if (!requestId || isNaN(requestId)) {
                throw new Error("Invalid course ID");
            }


            dispatch(getStudentApprovedTutorDetail(requestId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);


    const handlePayment = async () => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "x-auth-token": localStorage.getItem("student-token"),
                },
            };

            const sessionIds = StudentApprovedTutorDetailsApiData?.reqCourse?.courseSession?.map(
                (session) => session.id
            );

            const values = {
                order_type: "0",
                course_id: StudentApprovedTutorDetailsApiData?.reqCourse?.id,
                batch_id: "0",
                course_session: sessionIds,
                order_amount: StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price,
            };

            // console.log('StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price',StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price)

            if (StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price == '0' || StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price == '0.00') {
                const res = await axios.post(`${host}/api/payment/create-free-course`, values, config);

                if (res.data.statusCode == 200) {
                    setShowModal(false)
                    setShowPaymentModal(true)
                    setTimeout(() => {
                        setShowPaymentModal(false)
                        navigate('/student/dashboard');
                    }, 1000);


                } else {
                    toast.error(res.data.message || "Failed to enroll course. Please try again.");
                }
            } else {

                const res = await axios.post(`${host}/api/payment/create-intent-new`, values, config);

                if (res.data.statusCode == 200) {
                    const clientSecret = res.data.data.client_secret;


                    navigate('/student/session-payment', { state: { user: res.data.data } })


                } else {
                    toast.error(res.data.message || "Payment failed. Please try again.");
                }
            }
        } catch (err) {
            console.error("Error processing payment:", err);
            const errorMessage = err.response?.data?.message || "Something went wrong";
            toast.error(errorMessage);
        }
    };




    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;My Course Details
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingStudentApprovedTutorDetailsApi ?
                                    <Beatloader />
                                    :
                                    <>
                                        <h4 className="mb-3" />
                                        <div className="row mb-2">
                                            <div className="col-lg-3">
                                                <img
                                                    src={`${host}${StudentApprovedTutorDetailsApiData?.tutor?.profile_img}`}
                                                    className="img-fluid rounded w-auto"
                                                    style={{ height: "7.6rem" }}
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-5 py-4">
                                                <h4 className="mb-0">{StudentApprovedTutorDetailsApiData?.tutor?.name}</h4>
                                                <p className="mb-0 text-primary fw-bold">{StudentApprovedTutorDetailsApiData?.tutor?.tutordetails?.specialization}</p>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0 mt-2 text-end fw-bold">
                                                    <i className="fa-solid fa-calendar-days" style={{ fontSize: 13 }} />{" "}
                                                    Scheduled Date
                                                </p>
                                                <p
                                                    className="mb-0 ms-4 text-primary text-end me-5 fw-bold"
                                                    style={{ fontSize: 13 }}
                                                >
                                                    {StudentApprovedTutorDetailsApiData?.start_date}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row my-3">
                                            <div className="col-lg-4">
                                                <p className="mb-0">Class/Grade/General</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.reqCategory?.name}</h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Subject</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.reqSubCategory?.name}</h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Module</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.reqChildSubCategory?.name}</h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Created At</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.createdAt}</h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Session Start Date</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.start_date}</h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Session End Date</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.end_date}</h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Timing for 1st session</p>
                                                <h6>{StudentApprovedTutorDetailsApiData?.time_slot?.start_time_convert} - {StudentApprovedTutorDetailsApiData?.time_slot?.end_time_convert} ({StudentApprovedTutorDetailsApiData?.timeZoneAbb}) </h6>
                                            </div>
                                            <div className="col-lg-4">
                                                <p className="mb-0">Course Name</p>
                                                <h6 className="">{StudentApprovedTutorDetailsApiData?.reqCourse?.name}</h6>
                                            </div>
                                        </div>
                                        <div className="row mt-5">
                                            <h6 className="mb-0">Course Sessions</h6>
                                            {/* {StudentApprovedTutorDetailsApiData?.reqCourse?.courseSession?.slice()?.reverse()?.map((data,index) => ( */}
                                            {StudentApprovedTutorDetailsApiData?.reqCourse?.courseSession?.map((data, index) => (
                                                <div className="col-lg-4 my-2" >
                                                    <div className="card bg-white" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                        <div className="card-body" >
                                                            <h6 className="text-primary">Session - {index + 1}</h6>
                                                            <div className='d-flex justify-content-between'>
                                                                <h6 className="text-primary">Start Date: {data?.formated_start_date}  </h6>

                                                            </div>

                                                            <h6 className="text-primary">Time Slot: {data?.timeslots?.formated_start_end_time} ({StudentApprovedTutorDetailsApiData?.timeZoneAbb})</h6>
                                                            <h6 className="text-primary">Topic Details: {data?.topic_details}</h6>

                                                        </div>
                                                    </div>
                                                </div>


                                            ))}
                                        </div>
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td>No. of session</td>
                                                    <td>{StudentApprovedTutorDetailsApiData?.reqCourse?.no_of_session}</td>
                                                </tr>
                                                <tr>
                                                    <td>Course Main Price</td>
                                                    <td>{StudentApprovedTutorDetailsApiData?.reqCourse?.course_main_price}</td>
                                                </tr>
                                                <tr>
                                                    <td>Course Discount Price</td>
                                                    <td>{StudentApprovedTutorDetailsApiData?.reqCourse?.course_discount_price}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold">Total Course Price</td>
                                                    <td className="fw-bold">{StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price_with_symbol}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <p>Description: {StudentApprovedTutorDetailsApiData?.reqCourse?.description}</p>
                                            </div>
                                            {/* <div className="col-lg-6">
                                                <p>Course Session</p>
                                            </div>
                                            <div className="col-lg-6 d-flex justify-content-center">
                                                <button
                                                    className="btn btn-primary"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#viewcourseModal"
                                                >
                                                    View Course Session
                                                </button>
                                            </div> */}
                                        </div>
                                       {!StudentApprovedTutorDetailsApiData?.isPurchased &&
                                        <button
                                            type="button"
                                            className="btn btn-primary mt-3"
                                            style={{width:'min-content'}}
                                            onClick={() => setShowModal(true)}
                                        >
                                            Continue
                                        </button>}
                                    </>}
                            </main>

                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* View Course Session */}
                <div
                    className="modal fade"
                    id="viewcourseModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Course Session
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            {StudentApprovedTutorDetailsApiData?.reqCourse?.courseSession?.map((data, index) => (
                                <div className="modal-body" key={data?.id}>
                                    <h6 className="text-primary">{index + 1}. Start Date: {data?.formated_start_date}</h6>
                                    <h6 className="text-primary">Time Slot: {data?.timeslots?.formated_start_end_time} ({StudentApprovedTutorDetailsApiData?.timeZoneAbb})</h6>
                                    <h6 className="text-primary">Topic Details: {data?.topic_details}</h6>
                                </div>))}
                            <div className="modal-footer">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    <button type="button" class="btn btn-primary">Save changes</button> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Order Details Modal */}
                <Modal
                    className='modal tutor-details-modal border-0'
                    show={showModal}
                    onHide={() => setShowModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Order Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='border-0'>
                        <div className="row">
                            <div className="col-lg-12 mt-3">
                                <div className="card input-card-form bg-white">
                                    <div className="card-body">
                                        <div className="row position-relative">
                                            <div className="position-absolute">
                                                <p className="mb-0 text-end" style={{ fontSize: 13 }}>
                                                    <i>{StudentApprovedTutorDetailsApiData?.status}</i>
                                                </p>
                                                {/* <p className="mb-0 text-end" style={{ fontSize: 13 }}>
                                                            {StudentApprovedTutorDetailsApiData?.start_date}
                                                        </p> */}
                                            </div>
                                            <div className="col-lg-4">
                                                <img
                                                    src={`${host}${StudentApprovedTutorDetailsApiData?.tutor?.profile_img}`}
                                                    className="img-fluid rounded-circle"
                                                    style={{ height: "7.6rem", width: "auto" }}
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-8">
                                                <h5 className="mb-0 text-dark">{StudentApprovedTutorDetailsApiData?.tutor?.name}</h5>
                                                <p className="mb-0">{StudentApprovedTutorDetailsApiData?.tutor?.name}</p>
                                                <p className="mb-0">{StudentApprovedTutorDetailsApiData?.tutor?.tutordetails?.specialization}</p>
                                                {StudentApprovedTutorDetailsApiData?.tutor?.tutordetails?.experience && <p className="mb-0">{StudentApprovedTutorDetailsApiData?.tutor?.tutordetails?.experience} Year experience</p>}
                                                <div className="rating">
                                                    {Array.from({ length: 5 }, (_, index) => {
                                                        const averageRating = parseFloat(StudentApprovedTutorDetailsApiData?.tutor?.avarageRating || "0"); // Convert to number
                                                        if (index < Math.floor(averageRating)) {
                                                            return <i key={index} className="fas fa-star filled" />;
                                                        } else if (index < averageRating) {
                                                            return <i key={index} className="fas fa-star-half-alt filled" />;
                                                        } else {
                                                            return <i key={index} className="fas fa-star" />;
                                                        }
                                                    })}
                                                    <span>
                                                        {StudentApprovedTutorDetailsApiData?.tutor?.avarageRating}{" "}
                                                        <span className="text-primary">({StudentApprovedTutorDetailsApiData?.tutor?.total_rating_count} Ratings)</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 mt-3">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <p className="mb-0">Discount</p>
                                            </div>
                                            <div className="col-lg-6">
                                                <p className="mb-0 text-end">{StudentApprovedTutorDetailsApiData?.reqCourse?.course_discount_price}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <div className="modal-footer">
                        <div className="row w-100">
                            <div className="col-lg-6">
                                <p className="mb-0 fw-bold">Total Amount</p>
                            </div>
                            <div className="col-lg-6">
                                <p className="mb-0 text-end text-primary fw-bold">{StudentApprovedTutorDetailsApiData?.reqCourse?.total_course_price_with_symbol}</p>
                            </div>
                        </div>
                        <Link
                            //   to="/student/session-payment"
                            className="w-100">
                            <button onClick={handlePayment} className="btn btn-primary w-100" data-bs-dismiss="modal">Checkout</button>
                        </Link>
                    </div>
                </Modal>

                  {/* Payment Modal */}
                  <Modal
                    show={showPaymentModal} onHide={() => setShowPaymentModal(false)}
                    className="logout-modal"
                    id="paymentModal"
                    tabIndex={-1}

                >

                    <ModalBody

                        className="modal-body my-4"
                    // style={{
                    //     display: "flex",
                    //     flexDirection: "column",
                    //     alignItems: "center",
                    //     justifyContent: "center"
                    // }}
                    >
                        <img src="/assets/img/user/verified.gif" alt="" srcset="" />
                        <h4 className="mt-3">Enrollment succeeded!</h4>
                        <p className="text-center">
                            Your enrollment was completed successfully.
                            <br />
                            Thank you for enrolling!
                        </p>
                        <Link to="/student/dashboard">
                            <button
                                type="button"
                                className="btn btn-success"
                                data-bs-dismiss="modal"
                            >
                                Go To Your Dashboard
                            </button>
                        </Link>
                    </ModalBody>

                </Modal>
            </>

        </div>
    )
}

export default StudentCourseDetails